import { get, post } from 'services/api';
import { ICourse } from 'interface/course';
import { API_V4_BASE_URL } from 'settings';

import { setError } from './error';
import { decreaseLoading, increaseLoading } from './loading';
import { pushMessage } from './messages';
import { cleanModules } from './modules';

export const receiveCourse = (course: ICourse) => ({
  type: 'RECEIVE_COURSE',
  course,
});

const receiveCourseError = (error: any) => ({
  type: 'RECEIVE_COURSE_ERROR',
  error,
});

const receiveCourseProgress = (progress: number) => ({
  type: 'RECEIVE_COURSE_PROGRESS',
  progress,
});

const receiveCourseNews = (news: any) => ({
  type: 'RECEIVE_COURSE_NEWS',
  news,
});

export const cleanCourse = () => ({
  type: 'CLEAN_COURSE',
});

export const changeCourseField = (field: string, value: any) => ({
  type: 'CHANGE_COURSE_FIELD',
  field,
  value,
});

export const receiveCourseImageCover = (imageCover: string) => ({
  type: 'RECEIVE_COURSE_IMAGE_COVER',
  imageCover,
});

export const cleanCourseImageCover = () => ({
  type: 'CLEAN_COURSE_IMAGE_COVER',
});

export const loadTerms = (active: boolean) => ({
  type: 'INCREASE_LOADING_TERMS',
  active,
});

export const errorOnAccept = (active: boolean) => ({
  type: 'ERROR_ON_ACCEP_TERMS',
  active,
});

export const receiveCourseCertificate = (url: string) => ({
  type: 'RECEIVE_COURSE_CERTIFICATE_URL',
  url,
});

export const fetchCourseCertificateUrl = (courseHash: string) => async (dispatch: Function) => {
  try {
    const response = await get({ url: `/course/${courseHash}/certificate`, baseURL: API_V4_BASE_URL });
    dispatch(receiveCourseCertificate(response.data.data.certificate?.url || null));
    return response.data.data.certificate?.url || null;
  } catch (error) {
    throw error;
  }
};

export const fetchCourse =
  (courseHash: string, force = false) =>
  async (dispatch: Function, getState: Function) => {
    const course = getState().course;
    if ((course.hash === courseHash && !force) || !courseHash) {
      return;
    }

    dispatch(increaseLoading());

    await dispatch(cleanCourse());
    await dispatch(cleanModules());

    try {
      const response = await get({ url: `/learner/course/${courseHash}`, baseURL: API_V4_BASE_URL });

      dispatch(receiveCourse(response.data.data || {}));
      dispatch(decreaseLoading());

      return response.data;
    } catch (error) {
      dispatch(decreaseLoading());
      dispatch(receiveCourseError(error));
      dispatch(setError(error));

      throw error;
    }
  };

export const fetchCourseProgress = (courseHash: string) => async (dispatch: Function) => {
  try {
    const response = await get({ url: `/learner/course/${courseHash}/progress` });

    dispatch(receiveCourseProgress(response.data.data));

    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const updateCourseProgress = (data: any) => async (dispatch: Function) => {
  dispatch(receiveCourseProgress(data));
};

export const fetchCourseNews = (courseHash: string) => (dispatch: Function, getState: Function) => {
  const news = getState().course.news;
  if (!!news) {
    return;
  }
  dispatch(increaseLoading());
  get({
    url: `/learner/course/${courseHash}/news`,
    baseURL: API_V4_BASE_URL,
    validateStatus: () => true,
  }).then(
    (res) => {
      dispatch(receiveCourseNews(res.data.data || []));

      dispatch(decreaseLoading());
    },
    () => dispatch(decreaseLoading())
  );
};

export const agreeTerms = (courseHash: string, accepted: boolean) => async (dispatch: Function) => {
  dispatch(loadTerms(true));
  try {
    await post({ url: `/learner/course/${courseHash}/accept-terms`, data: { accepted } });
    accepted && dispatch(fetchCourse(courseHash, true));
    dispatch(loadTerms(false));
  } catch (err) {
    dispatch(loadTerms(false));
    dispatch(errorOnAccept(true));
  }
};

export const registerCourse = (courseHash: string) => async (dispatch: Function) => {
  dispatch(increaseLoading());

  try {
    await post({ url: `/learner/course/${courseHash}/register` });
  } catch (error) {
    dispatch(pushMessage('Um erro aconteceu...', 'error'));
    throw error;
  } finally {
    dispatch(decreaseLoading());
  }
};
